import { useState } from 'react';
import { Card, ModuleHeader, Tabs } from '../../components/ui';
import { IconMail } from '../../components/icons';
import { ChannelsSettings, ReplyChannelCard } from './ChannelsSettings';

/**
 * Meldekanäle (Kap. 9) und Telegram-Rückkanal (Kap. 5, Etappe 4) – vormals
 * Unterabschnitte der Systemeinstellungen, jetzt eine eigene Seite: Beide
 * Themen haben mit den übrigen Parametern dort (Freigabegrenzen,
 * Datensicherung, Änderungsverlauf) fachlich nichts zu tun.
 */
export function MeldekanaeleSettings() {
  const [tab, setTab] = useState<'uebersicht' | 'telegram'>('uebersicht');

  return (
    <div className="stack">
      <ModuleHeader
        icon={<IconMail width={22} height={22} />}
        title="Meldekanäle"
        subtitle="Wege, über die Meldungen eingehen, sowie der Rückkanal, über den Melder in Kontakt bleiben können."
        pill="Konfiguration"
        tone="info"
      />

      <Tabs
        active={tab}
        onChange={(value) => setTab(value as 'uebersicht' | 'telegram')}
        tabs={[
          { key: 'uebersicht', label: 'Übersicht' },
          { key: 'telegram', label: 'Telegram-Rückkanal' },
        ]}
      />

      {tab === 'uebersicht' ? (
        <ChannelsSettings />
      ) : (
        <Card
          title="Telegram-Rückkanal"
          subtitle="Ein zweiter, eigener Bot – unabhängig vom Meldekanal-Bot –, über den Melder nach dem Absenden in Kontakt bleiben und das Team antworten kann."
        >
          <ReplyChannelCard />
        </Card>
      )}
    </div>
  );
}
